export default "__VITE_ASSET__B$0NLbAN__"